import { type ProductFilterInput } from "../../type-and-hooks"

export const extractValidObjects = <InputObjectType extends Record<string, string | null | unknown>>(
  inputObject: InputObjectType,
  excludeEmptyStings: boolean = false
): InputObjectType => {
  const passCondition = (value: string | unknown | number): boolean => {
    if (typeof value === "number" && isNaN(value)) {
      return false
    }

    return excludeEmptyStings ? value !== null && value !== "" : value !== null
  }

  return Object.keys(inputObject)?.reduce(
    (accumulator, item) => ({ ...accumulator, ...(passCondition(inputObject[item]) && { [item]: inputObject[item] }) }),
    {}
  ) as InputObjectType
}

export const hasMandatoryFields = (objectToSearch: Partial<ProductFilterInput>): boolean => {
  const mandatoryFields: Array<keyof ProductFilterInput> = []
  let count = 0
  mandatoryFields.forEach(key => {
    return objectToSearch[key] ? count++ : null
  })
  return count === mandatoryFields.length
}
